export const wmoNZOscar = {
  "93004": {
    "stationName": "CAPE REINGA AWS",
    "latitude": -34.4294,
    "longitude": 172.6817,
    "height": 214,
    "country": "New Zealand"
  },
  "93008": {
    "stationName": "KAITAIA CTBTO",
    "latitude": -35.0678,
    "longitude": 173.2875,
    "height": 80,
    "country": "New Zealand"
  },
  "93012": {
    "stationName": "KAITAIA OBSERVATORY",
    "latitude": -35.1327777778,
    "longitude": 173.2638888889,
    "height": 85,
    "country": "New Zealand"
  },
  "93014": {
    "stationName": "KAITAIA AIRPORT AWS",
    "latitude": -35.067792,
    "longitude": 173.286279,
    "height": 82.3,
    "country": "New Zealand"
  },
  "93017": {
    "stationName": "RADAR Kaeo",
    "latitude": -35.0805555556,
    "longitude": 173.8052777778,
    "height": 383,
    "country": "New Zealand"
  },
  "93021": {
    "stationName": "KERIKERI AERO AWS",
    "latitude": -35.26278,
    "longitude": 173.91136,
    "height": 149.95,
    "country": "New Zealand"
  },
  "93023": {
    "stationName": "PURERUA AWS",
    "latitude": -35.1253,
    "longitude": 174.0167,
    "height": 84.8,
    "country": "New Zealand"
  },
  "93034": {
    "stationName": "KAIKOHE AWS",
    "latitude": -35.4172222222,
    "longitude": 173.8227777778,
    "height": 204,
    "country": "New Zealand"
  },
  "93057": {
    "stationName": "WHANGAREI AERO AWS",
    "latitude": -35.770556,
    "longitude": 174.362778,
    "height": 37.9,
    "country": "New Zealand"
  },
  "93069": {
    "stationName": "MOKOHINAU ISLAND AWS",
    "latitude": -35.9027777778,
    "longitude": 175.1152777778,
    "height": 69.1,
    "country": "New Zealand"
  },
  "93072": {
    "stationName": "RADAR Tamahunga",
    "latitude": -36.2833333333,
    "longitude": 174.7105555556,
    "height": 453,
    "country": "New Zealand"
  },
  "93098": {
    "stationName": "WHENUAPAI AERO AWS",
    "latitude": -36.7869444444,
    "longitude": 174.6302777778,
    "height": 30,
    "country": "New Zealand"
  },
  "93103": {
    "stationName": "WHANGAPARAOA AWS",
    "latitude": -36.6027,
    "longitude": 174.8346,
    "height": 98.94,
    "country": "New Zealand"
  },
  "93110": {
    "stationName": "AUCKLAND AERO AWS",
    "latitude": -37.0088888889,
    "longitude": 174.8072222222,
    "height": 7,
    "country": "New Zealand"
  },
  "93112": {
    "stationName": "WHENUAPAI",
    "latitude": -36.7927777778,
    "longitude": 174.6213888889,
    "height": 30,
    "country": "New Zealand"
  },
  "93129": {
    "stationName": "WHITIANGA AERO AWS",
    "latitude": -36.8322222222,
    "longitude": 175.6752777778,
    "height": 3.66,
    "country": "New Zealand"
  },
  "93146": {
    "stationName": "PAEROA AWS",
    "latitude": -37.3705555556,
    "longitude": 175.6836111111,
    "height": 17.5,
    "country": "New Zealand"
  },
  "93173": {
    "stationName": "HAMILTON AERO AWS",
    "latitude": -37.86083,
    "longitude": 175.33167,
    "height": 52.4,
    "country": "New Zealand"
  },
  "93186": {
    "stationName": "TAURANGA AERO AWS",
    "latitude": -37.6705555556,
    "longitude": 176.1963888889,
    "height": 3.96,
    "country": "New Zealand"
  },
  "93191": {
    "stationName": "WHAKATANE AERO AWS",
    "latitude": -37.9247222222,
    "longitude": 176.9183333333,
    "height": 6.1,
    "country": "New Zealand"
  },
  "93196": {
    "stationName": "HICKS BAY AWS",
    "latitude": -37.5611111111,
    "longitude": 178.3144444444,
    "height": 44.5,
    "country": "New Zealand"
  },
  "93201": {
    "stationName": "PORT TAHAROA AWS",
    "latitude": -38.171131,
    "longitude": 174.704089,
    "height": 16.2,
    "country": "New Zealand"
  },
  "93226": {
    "stationName": "TAUMARUNUI AWS",
    "latitude": -38.8872222222,
    "longitude": 175.3325,
    "height": 184.3,
    "country": "New Zealand"
  },
  "93245": {
    "stationName": "TAUPO AERO AWS",
    "latitude": -38.7425,
    "longitude": 176.0808333333,
    "height": 406.9,
    "country": "New Zealand"
  },
  "93247": {
    "stationName": "ROTORUA AERO AWS",
    "latitude": -38.1058333333,
    "longitude": 176.3147222222,
    "height": 285.9,
    "country": "New Zealand"
  },
  "93257": {
    "stationName": "GALATEA AERO AWS",
    "latitude": -38.4083333333,
    "longitude": 176.7422222222,
    "height": 168,
    "country": "New Zealand"
  },
  "93261": {
    "stationName": "RADAR Mamaku",
    "latitude": -38.065,
    "longitude": 176.0616666667,
    "height": 604,
    "country": "New Zealand"
  },
  "93285": {
    "stationName": "TOLAGA BAY AWS",
    "latitude": -38.3822222222,
    "longitude": 178.3077777778,
    "height": 5,
    "country": "New Zealand"
  },
  "93292": {
    "stationName": "GISBORNE AERO AWS",
    "latitude": -38.6586111111,
    "longitude": 177.985,
    "height": 5,
    "country": "New Zealand"
  },
  "93309": {
    "stationName": "NEW PLYMOUTH AERO AWS",
    "latitude": -39.0077777778,
    "longitude": 174.1836111111,
    "height": 29.6,
    "country": "New Zealand"
  },
  "93313": {
    "stationName": "HAWERA AWS",
    "latitude": -39.60991,
    "longitude": 174.2916,
    "height": 98.3,
    "country": "New Zealand"
  },
  "93327": {
    "stationName": "WHANGANUI AERO AWS",
    "latitude": -39.96123,
    "longitude": 175.02585,
    "height": 13.4,
    "country": "New Zealand"
  },
  "93339": {
    "stationName": "WAIOURU AERO AWS",
    "latitude": -39.4461111111,
    "longitude": 175.6577777778,
    "height": 818.69,
    "country": "New Zealand"
  },
  "93373": {
    "stationName": "NAPIER AERO AWS",
    "latitude": -39.4702777778,
    "longitude": 176.8644444444,
    "height": 2,
    "country": "New Zealand"
  },
  "93376": {
    "stationName": "CAPE KIDNAPPERS AWS",
    "latitude": -39.645,
    "longitude": 177.0913888889,
    "height": 109,
    "country": "New Zealand"
  },
  "93392": {
    "stationName": "RADAR Mahia",
    "latitude": -39.1680555556,
    "longitude": 177.8877777778,
    "height": 403,
    "country": "New Zealand"
  },
  "93393": {
    "stationName": "MAHIA AWS",
    "latitude": -39.1172222222,
    "longitude": 177.9616666667,
    "height": 134.6,
    "country": "New Zealand"
  },
  "93397": {
    "stationName": "WAIROA AERO AWS",
    "latitude": -39.0163888889,
    "longitude": 177.4033333333,
    "height": 11.99,
    "country": "New Zealand"
  },
  "93400": {
    "stationName": "RADAR New Plymouth",
    "latitude": -39.0102777778,
    "longitude": 174.1769444444,
    "height": 30,
    "country": "New Zealand"
  },
  "93402": {
    "stationName": "OHAKEA AERO AWS",
    "latitude": -40.1958333333,
    "longitude": 175.3811111111,
    "height": 50,
    "country": "New Zealand"
  },
  "93404": {
    "stationName": "PALMERSTON NORTH AERO AWS",
    "latitude": -40.31858,
    "longitude": 175.61459,
    "height": 38.75,
    "country": "New Zealand"
  },
  "93410": {
    "stationName": "LEVIN AWS",
    "latitude": -40.6197222222,
    "longitude": 175.2594444444,
    "height": 13.6,
    "country": "New Zealand"
  },
  "93417": {
    "stationName": "PARAPARAUMU AERODROME",
    "latitude": -40.9044444444,
    "longitude": 174.9838888889,
    "height": 6,
    "country": "New Zealand"
  },
  "93420": {
    "stationName": "PARAPARAUMU AERO AWS",
    "latitude": -40.9044444444,
    "longitude": 174.985,
    "height": 5.78,
    "country": "New Zealand"
  },
  "93431": {
    "stationName": "RADAR Outlook Hill",
    "latitude": -41.3113888889,
    "longitude": 174.6461111111,
    "height": 548,
    "country": "New Zealand"
  },
  "93436": {
    "stationName": "WELLINGTON AIRPORT",
    "latitude": -41.3312,
    "longitude": 174.8056,
    "height": 4,
    "country": "New Zealand"
  },
  "93437": {
    "stationName": "KELBURN AWS",
    "latitude": -41.2844444444,
    "longitude": 174.7677777778,
    "height": 125.4,
    "country": "New Zealand"
  },
  "93439": {
    "stationName": "WELLINGTON AERO AWS",
    "latitude": -41.33121,
    "longitude": 174.80568,
    "height": 4,
    "country": "New Zealand"
  },
  "93441": {
    "stationName": "TAKAPAU PLAINS AWS",
    "latitude": -40.0416666667,
    "longitude": 176.2683333333,
    "height": 346.3,
    "country": "New Zealand"
  },
  "93467": {
    "stationName": "MASTERTON AERO AWS",
    "latitude": -40.9761111111,
    "longitude": 175.6388888889,
    "height": 110.95,
    "country": "New Zealand"
  },
  "93479": {
    "stationName": "NGAWI AWS",
    "latitude": -41.5883333333,
    "longitude": 175.2336111111,
    "height": 5.5,
    "country": "New Zealand"
  },
  "93493": {
    "stationName": "CAPE TURNAGAIN AWS",
    "latitude": -40.4847222222,
    "longitude": 176.6152777778,
    "height": 285,
    "country": "New Zealand"
  },
  "93498": {
    "stationName": "CASTLEPOINT AWS",
    "latitude": -40.9041666667,
    "longitude": 176.2119444444,
    "height": 118,
    "country": "New Zealand"
  },
  "93515": {
    "stationName": "WESTPORT AERO AWS",
    "latitude": -41.7405555556,
    "longitude": 171.5797222222,
    "height": 4,
    "country": "New Zealand"
  },
  "93527": {
    "stationName": "FAREWELL SPIT AWS",
    "latitude": -40.5447222222,
    "longitude": 173.0008333333,
    "height": 3.4,
    "country": "New Zealand"
  },
  "93546": {
    "stationName": "NELSON AERO AWS",
    "latitude": -41.3005555556,
    "longitude": 173.2158333333,
    "height": 5.13,
    "country": "New Zealand"
  },
  "93562": {
    "stationName": "STEPHENS ISLAND AWS",
    "latitude": -40.66511,
    "longitude": 173.99969,
    "height": 185.7,
    "country": "New Zealand"
  },
  "93579": {
    "stationName": "WOODBOURNE AERO AWS",
    "latitude": -41.5211111111,
    "longitude": 173.8641666667,
    "height": 33.26,
    "country": "New Zealand"
  },
  "93586": {
    "stationName": "BROTHERS ISLAND AWS",
    "latitude": -41.1030555556,
    "longitude": 174.4416666667,
    "height": 66.65,
    "country": "New Zealand"
  },
  "93597": {
    "stationName": "CAPE CAMPBELL AWS",
    "latitude": -41.7263888889,
    "longitude": 174.2761111111,
    "height": 4.9,
    "country": "New Zealand"
  },
  "93605": {
    "stationName": "Reefton",
    "latitude": -42.11578,
    "longitude": 171.86014,
    "height": 198,
    "country": "New Zealand"
  },
  "93613": {
    "stationName": "RADAR Hokitika",
    "latitude": -42.7383333333,
    "longitude": 171.0616666667,
    "height": 334,
    "country": "New Zealand"
  },
  "93615": {
    "stationName": "HOKITIKA AERO AWS",
    "latitude": -42.71296,
    "longitude": 170.98437,
    "height": 38.1,
    "country": "New Zealand"
  },
  "93630": {
    "stationName": "ARTHURS PASS AWS",
    "latitude": -42.9415,
    "longitude": 171.5629,
    "height": 745,
    "country": "New Zealand"
  },
  "93652": {
    "stationName": "Hanmer Forest",
    "latitude": -42.53433,
    "longitude": 172.85098,
    "height": 363,
    "country": "New Zealand"
  },
  "93656": {
    "stationName": "CULVERDEN AWS",
    "latitude": -42.77014,
    "longitude": 172.88947,
    "height": 174.4,
    "country": "New Zealand"
  },
  "93678": {
    "stationName": "KAIKOURA AWS",
    "latitude": -42.4202777778,
    "longitude": 173.6961111111,
    "height": 107.3,
    "country": "New Zealand"
  },
  "93700": {
    "stationName": "Franz Josef Aerodrome",
    "latitude": -43.36548,
    "longitude": 170.13428,
    "height": 80,
    "country": "New Zealand"
  },
  "93709": {
    "stationName": "HAAST AWS",
    "latitude": -43.86,
    "longitude": 169.0063888889,
    "height": 3,
    "country": "New Zealand"
  },
  "93721": {
    "stationName": "MILFORD AERO AWS",
    "latitude": -44.6727777778,
    "longitude": 167.9227777778,
    "height": 3.05,
    "country": "New Zealand"
  },
  "93729": {
    "stationName": "WANAKA AERO AWS",
    "latitude": -44.7219444444,
    "longitude": 169.2438888889,
    "height": 348,
    "country": "New Zealand"
  },
  "93737": {
    "stationName": "PUKAKI AERO AWS",
    "latitude": -44.245,
    "longitude": 170.1166666667,
    "height": 480.06,
    "country": "New Zealand"
  },
  "93738": {
    "stationName": "MT COOK AERO AWS",
    "latitude": -43.765,
    "longitude": 170.1313888889,
    "height": 656.23,
    "country": "New Zealand"
  },
  "93747": {
    "stationName": "TARA HILLS AWS",
    "latitude": -44.5261111111,
    "longitude": 169.8894444444,
    "height": 484.47,
    "country": "New Zealand"
  },
  "93752": {
    "stationName": "ALEXANDRA AERO AWS",
    "latitude": -45.2145,
    "longitude": 169.3755,
    "height": 229.21,
    "country": "New Zealand"
  },
  "93753": {
    "stationName": "FAIRLIE AWS",
    "latitude": -44.0375,
    "longitude": 170.7702777778,
    "height": 396,
    "country": "New Zealand"
  },
  "93765": {
    "stationName": "ASHBURTON AERO AWS",
    "latitude": -43.9030555556,
    "longitude": 171.8038888889,
    "height": 90.8,
    "country": "New Zealand"
  },
  "93769": {
    "stationName": "RADAR Rakaia",
    "latitude": -43.7847222222,
    "longitude": 172.0230555556,
    "height": 103,
    "country": "New Zealand"
  },
  "93773": {
    "stationName": "TIMARU AERO AWS",
    "latitude": -44.305,
    "longitude": 171.2213888889,
    "height": 27.13,
    "country": "New Zealand"
  },
  "93774": {
    "stationName": "ARTHURS PASS AWS",
    "latitude": -42.9415,
    "longitude": 171.5629,
    "height": 745,
    "country": "New Zealand"
  },
  "93781": {
    "stationName": "CHRISTCHURCH AERO AWS",
    "latitude": -43.4897222222,
    "longitude": 172.5269444444,
    "height": 37.5,
    "country": "New Zealand"
  },
  "93790": {
    "stationName": "Tawhaki National Aerospace Centre",
    "latitude": -43.8336,
    "longitude": 172.5325,
    "height": 8,
    "country": "New Zealand"
  },
  "93791": {
    "stationName": "Lincoln Broadfield",
    "latitude": -43.6262,
    "longitude": 172.4704,
    "height": 18,
    "country": "New Zealand"
  },
  "93792": {
    "stationName": "LE BONS BAY AWS",
    "latitude": -43.7458333333,
    "longitude": 173.1216666667,
    "height": 235.8,
    "country": "New Zealand"
  },
  "93796": {
    "stationName": "OAMARU AERO AWS",
    "latitude": -44.9719444444,
    "longitude": 171.0808333333,
    "height": 30.2,
    "country": "New Zealand"
  },
  "93800": {
    "stationName": "SECRETARY ISLAND AWS",
    "latitude": -45.2208333333,
    "longitude": 166.8847222222,
    "height": 17.6,
    "country": "New Zealand"
  },
  "93805": {
    "stationName": "PUYSEGUR POINT AWS",
    "latitude": -46.1561111111,
    "longitude": 166.6127777778,
    "height": 43.5,
    "country": "New Zealand"
  },
  "93811": {
    "stationName": "MANAPOURI AERO AWS",
    "latitude": -45.5325,
    "longitude": 167.6413888889,
    "height": 209.39,
    "country": "New Zealand"
  },
  "93817": {
    "stationName": "Lauder Observatory",
    "latitude": -45.0385,
    "longitude": 169.6843,
    "height": 371,
    "country": "New Zealand"
  },
  "93831": {
    "stationName": "QUEENSTOWN AERO AWS",
    "latitude": -45.0175,
    "longitude": 168.74,
    "height": 356.9,
    "country": "New Zealand"
  },
  "93834": {
    "stationName": "LUMSDEN AWS",
    "latitude": -45.745,
    "longitude": 168.4497222222,
    "height": 192.9,
    "country": "New Zealand"
  },
  "93838": {
    "stationName": "BIRCHWOOD AWS",
    "latitude": -45.9438888889,
    "longitude": 167.9005555556,
    "height": 142.2,
    "country": "New Zealand"
  },
  "93844": {
    "stationName": "INVERCARGILL AIRPORT",
    "latitude": -46.41727,
    "longitude": 168.33045,
    "height": 1,
    "country": "New Zealand"
  },
  "93845": {
    "stationName": "INVERCARGILL AIRPORT AWS",
    "latitude": -46.41083,
    "longitude": 168.31778,
    "height": 1.5,
    "country": "New Zealand"
  },
  "93847": {
    "stationName": "RADAR INVERCARGILL",
    "latitude": -46.4177777778,
    "longitude": 168.3305555556,
    "height": 10,
    "country": "New Zealand"
  },
  "93864": {
    "stationName": "GORE AWS",
    "latitude": -46.1116666667,
    "longitude": 168.8875,
    "height": 123,
    "country": "New Zealand"
  },
  "93887": {
    "stationName": "NUGGET POINT AWS",
    "latitude": -46.4475,
    "longitude": 169.8119444444,
    "height": 131.1,
    "country": "New Zealand"
  },
  "93888": {
    "stationName": "RADAR Lamb Hill",
    "latitude": -45.6895,
    "longitude": 170.41869,
    "height": 757.87,
    "country": "New Zealand"
  },
  "93891": {
    "stationName": "DUNEDIN AERO AWS",
    "latitude": -45.9266666667,
    "longitude": 170.1966666667,
    "height": 1,
    "country": "New Zealand"
  },
  "93909": {
    "stationName": "SOUTH WEST CAPE AWS",
    "latitude": -47.2766666667,
    "longitude": 167.4627777778,
    "height": 102.9,
    "country": "New Zealand"
  },
  "93929": {
    "stationName": "ENDERBY ISLAND AWS",
    "latitude": -50.49325,
    "longitude": 166.29569,
    "height": 38.6,
    "country": "New Zealand"
  },
  "93945": {
    "stationName": "CAMPBELL ISLAND AWS",
    "latitude": -52.55059,
    "longitude": 169.14978,
    "height": 14.84,
    "country": "New Zealand"
  },
  "93946": {
    "stationName": "CAMPBELL ISLAND AWS",
    "latitude": -52.55059,
    "longitude": 169.14978,
    "height": 14.84,
    "country": "New Zealand"
  },
  "93947": {
    "stationName": "CAMPBELL ISLAND AWS",
    "latitude": -52.55059,
    "longitude": 169.14978,
    "height": 14.84,
    "country": "New Zealand"
  },
  "93985": {
    "stationName": "CHATHAM ISLAND AIRPORT",
    "latitude": -43.81676,
    "longitude": -176.47502,
    "height": 13.1,
    "country": "New Zealand"
  },
  "93988": {
    "stationName": "CHATHAM ISLAND CTBTO",
    "latitude": -43.81694,
    "longitude": -176.47498,
    "height": 15,
    "country": "New Zealand"
  },
  "93994": {
    "stationName": "RAOUL ISLAND AWS",
    "latitude": -29.24413,
    "longitude": -177.92891,
    "height": 38.7,
    "country": "New Zealand"
  },
  "93997": {
    "stationName": "RAOUL ISLAND",
    "latitude": -29.2447222222,
    "longitude": -177.9288888889,
    "height": 47.7,
    "country": "New Zealand"
  }
};
